module.exports = __webpack_public_path__ + "static/media/Pixel4.png?v=6edaca90";